import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import AmchartsDerevo from "../amcharts-derevo/index";
import "../../assets/styles/cards.scss";
import "../../assets/styles/main.scss";
import categoryIcons from "./categoryIcons";

class SalesMainCard extends React.Component {
  constructor(props) {
    super(props);
    this.ws = this.props.ws;
    this.state = {
      data: [],
      branchData: [],
      productData: [],
      channelData: [],
      combinedData: [],
      topFive: []
    };
  }
  getObjectByid = async action => {
    await this.ws.connect(action).then(response => {
      this.setState({
        data: this.state.data.concat([response])
      });
    });
  };

  configScatter = {
    type: "scatter_chart",
    titles: {
      xAxis: "Ventas",
      yAxis: "Unidades"
    },
    colors: [
      "rgba(69, 42, 172, 0.3)",
      "rgba(72, 89, 194, 0.6)",
      "rgba(69, 42, 172, 0.75)",
      "rgba(69, 42, 172, 0.86)",
      "rgba(69, 42, 172, 1)"
    ],
    seriesType: ["ColumnSeries"],
    orientation: "both",
    configChart: {
      category: "category",
      value: "value"
    },
    tooltip: {
      text: "[#000 font-size: 15px]{name} - X: {valueX}, Y: {valueY}[/]" //Para que se muestre el valor se de agregar entre llaves {valueY} o {valueX}, para agregar la categoria se agrega {name}
    },
    ordering: false,
    scrollingY: false,
    scrollingX: false
  };
  configBars = {
    type: "simple",
    titles: {
      xAxis: "Category",
      yAxis: "Values"
    },
    colors: {
      max: "#452AAC",
      min: "#927CEA"
    },
    seriesType: ["ColumnSeries"],
    orientation: "horizontal",
    configChart: {
      category: "category",
      value: "value"
    },
    ordering: {
      type: "asc",
      value: "value"
    },
    tooltip: {
      text: "{valueX}"
    },
    zoom: false,
    scrollingY: false,
    scrollingX: false
  };
  configColumns = {
    type: "column_line_mix",
    titles: {
      xAxis: "Month",
      yAxis: "Values"
    },
    colors: ["rgba(146, 124, 234, 0.75)", "rgba(69, 42, 172, 1)"],
    seriesType: ["ColumnSeries", "LineSeries"],
    orientation: "vertical",
    configChart: {
      category: "mes",
      value1: "income",
      value2: "expenses"
    },
    ordering: {
      type: "desc",
      value: "income"
    },
    tooltip: {
      text:
        "[ font-size: 15px]{name} in {categoryX}:\n[/][ font-size: 20px]{valueY}[/] {additional}"
    },
    zoom: false,
    scrollingY: false,
    scrollingX: false
  };

  getData = async () => {
    this.state.data = [];
    await this.getObjectByid("getProductSales");
    await this.getObjectByid("getBranchSales");
    await this.getObjectByid("getChannelSales");
    await this.getObjectByid("getSalesCombinedChart");
    await this.getObjectByid("getTopFiveSales");
    let topFive = [];
    if (this.state.data.length >= 1) {
      for (let i = 0; i < 5; i++) {
        if (this.state.data[4].data.table[i]) {
          topFive[i] = this.state.data[4].data.table[i];
        } else {
          topFive[i] = {
            ClasificacionProducto: "N/A",
            "Venta Actual": "-",
            "Venta Año anterior": "-",
            "Venta Promedio": "-"
          };
        }
      }
      this.setState({
        branchData: await this.state.data[1].data.table.map(data => {
          return { category: data.Sucursal, value: data.Monto };
        }),
        productData: await this.state.data[0].data.table.map(data => {
          return {
            "a-x": data["Monto  Año Actual"],
            "a-y": data["Cantidad  Año Actual"]
          };
        }),
        channelData: await this.state.data[2].data.table.map(channel => {
          return { category: channel.Canal, value: channel.Monto };
        }),
        combinedData: await this.state.data[3].data.table.map(data => {
          let variation = data["Variación"].substring(
            0,
            data["Variación"].length - 1
          );
          let percentageToAmount = (variation / 100) * data["Año Actual"];
          return {
            mes: data.mes,
            income: data["Año Actual"],
            expenses: percentageToAmount
          };
        }),
        topFive: await topFive.map(data => {
          return {
            category: data.ClasificacionProducto,
            currentSale: data["Venta Actual"],
            lySale: data["Venta Año anterior"],
            averageSale: data["Venta Promedio"]
          };
        })
      });
    }
  };

  async componentDidMount() {
    this.getData();
  }
  async componentWillReceiveProps({ update }) {
    if (this.update !== update) {
      this.setState({ ...this.state, update });
      await this.getData();
    }
  }
  render() {
    return (
      <Row>
        <Card className="col-12 border-0">
          <div>
            <Card.Title className="py-4 mb-4 text-center text-sm-left">
              <div className="top-left-icon sale-icon bg-sales d-flex align-items-center justify-content-center">
                <img alt="" className="img-fluid" src={ require( "../../assets/icons/icon-hand.svg" ) }/>
              </div>
              <span className="ml-sm-5 pl-sm-5 text-muted is-font-weight--extra-bold">VENTAS</span>
            </Card.Title>
            {this.state.topFive.length > 0 ? (
              <div>{this.topFive(this.state.topFive)}</div>
            ) : (
              <h2>Cargando...</h2>
            )}

            <Row className="mt-sm-5">
              <Col md={6}>
                {this.state.combinedData.length > 0 ? (
                  <AmchartsDerevo
                    type={"xy-charts"}
                    data={this.state.combinedData}
                    id_div="div1"
                    title={""}
                    config={this.configColumns}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
              <Col md={6}>
                {this.state.branchData.length > 0 ? (
                  <AmchartsDerevo
                    type={"xy-charts"}
                    data={this.state.branchData}
                    id_div="div2"
                    title={"Ventas Sucursales"}
                    config={this.configBars}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
            </Row>
            <Row className="mt-sm-5">
              <Col md={6}>
                {this.state.productData.length > 0 ? (
                  <AmchartsDerevo
                    type={"xy-charts"}
                    data={this.state.productData}
                    id_div="div3"
                    title={"Productos"}
                    config={this.configScatter}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
              <Col md={6}>
                {" "}
                {this.state.channelData.length > 0 ? (
                  <AmchartsDerevo
                    type={"xy-charts"}
                    data={this.state.channelData}
                    id_div="div4"
                    title={"Canales"}
                    config={this.configBars}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
            </Row>
          </div>
        </Card>
      </Row>
    );
  }
  topFive = elements => {
    return (
      <Row className="justify-content-sm-around">
        <Col xs={6} sm={2} className="mb-4 mb-sm-0 d-flex align-items-start flex-column">
          {" "}
          <strong className={`is-h5 mb-3 w-100 title__${this.props.customClass}`}>{elements[0].category}</strong>
          <div className="d-flex w-100">
            <span class="d-none d-sm-block">{ categoryIcons( elements[0].category ) }</span>
            <div className="d-flex flex-column w-100">
              <strong className="is-h4 is-font-weight--bold">{elements[0].currentSale}</strong>
              <strong className="d-flex justify-content-between text-muted is-h6 is-font-weight--semi-bold">
                <span>vs AA</span>
                <span>{ elements[0].lySale }</span>
              </strong>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={2} className="mb-4 mb-sm-0 d-flex align-items-start flex-column">
          {" "}
          <strong className={`is-h5 mb-3 w-100 title__${this.props.customClass}`}>{elements[1].category}</strong>
          <div className="d-flex w-100">
            <span class="d-none d-sm-block">{ categoryIcons( elements[1].category ) }</span>
            <div className="d-flex flex-column w-100">
              <strong className="is-h4 is-font-weight--bold">{elements[1].currentSale}</strong>
              <strong className="d-flex justify-content-between text-muted is-h6 is-font-weight--semi-bold">
                <span>vs AA</span> 
                <span>{ elements[1].lySale }</span>
              </strong>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={2} className="mb-4 mb-sm-0 d-flex align-items-start flex-column">
          {" "}
          <strong className={`is-h5 mb-3 w-100 title__${this.props.customClass}`}>{elements[2].category}</strong>
          <div className="d-flex w-100">
            <span class="d-none d-sm-block">{ categoryIcons( elements[2].category ) }</span>
            <div className="d-flex flex-column w-100">
              <strong className="is-h4 is-font-weight--bold">{elements[2].currentSale}</strong>
              <strong className="d-flex justify-content-between text-muted is-h6 is-font-weight--semi-bold">
                <span>vs AA</span>
                <span>{ elements[2].lySale }</span>
              </strong>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={2} className="mb-4 mb-sm-0 d-flex align-items-start flex-column">
          {" "}
          <strong className={`is-h5 mb-3 w-100 title__${this.props.customClass}`}>{elements[3].category}</strong>
          <div className="d-flex w-100">
            <span class="d-none d-sm-block">{ categoryIcons( elements[3].category ) }</span>
            <div className="d-flex flex-column w-100">
              <strong className="is-h4 is-font-weight--bold">{elements[3].currentSale}</strong>
              <strong className="d-flex justify-content-between text-muted is-h6 is-font-weight--semi-bold">
                <span>vs AA</span> 
                <span>{ elements[3].lySale }</span>
              </strong>
            </div>
          </div>
        </Col>
        <Col xs={6} sm={2} className="mb-4 mb-sm-0 d-flex align-items-start flex-column">
          {" "}
          <strong className={`is-h5 mb-3 w-100 title__${this.props.customClass}`}>{elements[4].category}</strong>
          <div className="d-flex w-100">
            <span class="d-none d-sm-block">{ categoryIcons( elements[4].category ) }</span>
            <div className="d-flex flex-column w-100">
              <strong className="is-h4 is-font-weight--bold">{elements[4].currentSale}</strong>
              <strong className="d-flex justify-content-between text-muted is-h6 is-font-weight--semi-bold">
                <span>vs AA</span> 
                <span>{ elements[4].lySale }</span>
              </strong>
            </div>
          </div>
        </Col>
      </Row>
    );
  };
}

export default SalesMainCard;
